
import { trigger, state, style, animate, transition } from '@angular/animations';
import { Component, OnInit, Input, HostListener, ViewEncapsulation } from '@angular/core';
import { FiltersService } from '../../services/filters.service'


@Component({
  selector: 'filter-checkbox-block',
  templateUrl: './filter-checkbox-block.component.html',
  styleUrls: ['./filter-checkbox-block.component.sass']

})

export class FilterCheckboxBlockComponent implements OnInit {

  public isBlockOpened: boolean = false;
  public filtersState: { [key: string]: any } = {};
  public showRightColumn: boolean = true; // Состояние отображения правой колонки

  constructor(private filters: FiltersService) { }

  ngOnInit() {

    this.filters.getClearedFilterSubject().asObservable().subscribe(clearedName => {
      if (clearedName == 'all') {

        const filtersnames = Object.keys(this.filtersState)
        for (let i = 0; i < filtersnames.length; i++) {
          const name = filtersnames[i]
          delete this.filtersState[name] //= false;
          this.filters.setFilterState(name, false)
        }
      } else {
        delete this.filtersState[clearedName] //= false;
        this.filters.setFilterState(clearedName, false)
      }
    })

        // Подписка на изменения состояния выбранного радио-батона
        // this.filters.getSelectedFreight$().subscribe(selectedFreight => {
        //   this.showRightColumn = selectedFreight !== 'shippedFreightVv';
        // });
    
        // Подписка на изменения состояния правой колонки (не обязательно, но для уверенности)
        this.filters.getShowRightColumn$().subscribe(showRight => {
          this.showRightColumn = showRight;
        });

  }

  public chackboxTriggered(event: any) {
    this.filters.setFilterState(event.srcElement.id, event.srcElement.checked)
  }

  public isShowToggleTriggered(isShow) {
    this.isBlockOpened = isShow;
  }
}
